import { render, staticRenderFns } from "./TopUpAmountItem.vue?vue&type=template&id=c5582b00&scoped=true&"
import script from "./TopUpAmountItem.vue?vue&type=script&lang=js&"
export * from "./TopUpAmountItem.vue?vue&type=script&lang=js&"
import style0 from "./TopUpAmountItem.vue?vue&type=style&index=0&id=c5582b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5582b00",
  null
  
)

export default component.exports